<ul class="timeline_body">
  <!-- ENTRY WRAPPER -->
  <li
    *ngFor="let entry of internalTimelineSortedByBeginDate; let i = index"
    [ngClass]="{ selected: entry.id === selectInteractionId, current: entry.id === currentInteractionId }"
  >
    <ng-container *ngIf="{ hasComment: entry && entry.memo && entry.memo.date && entry.memo.message } as entryData">
      <!-- WITH COMMENT -->
      <button matRipple *ngIf="entryData.hasComment" [cngTooltip]="tooltipContentRef" placement="right" (click)="select(entry)">
        <ng-container [ngTemplateOutlet]="entryContent"></ng-container>
        <span class="comment_icon cng-ico_note"></span>
      </button>

      <!-- WITHOUT COMMENT -->
      <button matRipple *ngIf="!entryData.hasComment" (click)="select(entry)">
        <ng-container [ngTemplateOutlet]="entryContent"></ng-container>
      </button>

      <ng-container *ngIf="canLink && canSelectToLink(entry)">
        <ng-container *ngIf="entry.hasVisibility">
          <ng-container *cngHasPermission="'CSR_MAIL_INCOMING::mail_in_process_with_skill:link'">
            <mat-checkbox
              (change)="saveTimelineSelected()"
              (click)="$event.stopPropagation()"
              [(ngModel)]="entry.selected"
              id="timelineRowSelected-{{ i }}"
              name="timelineRowSelected-{{ i }}"
              title="{{ 'agent:contact.mailactions.select_link' | translate }} : {{ entry.description }}"
            ></mat-checkbox>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!entry.hasVisibility">
          <ng-container *cngHasPermission="'CSR_MAIL_INCOMING::mail_in_process_without_skill:link'">
            <mat-checkbox
              (change)="saveTimelineSelected()"
              (click)="$event.stopPropagation()"
              [(ngModel)]="entry.selected"
              id="timelineRowSelectedNoVisibility-{{ i }}"
              name="timelineRowSelectedNoVisibility-{{ i }}"
              title="{{ 'agent:contact.mailactions.select_link' | translate }} : {{ entry.description }}"
            ></mat-checkbox>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- ENTRY CONTENT -->
      <ng-template #entryContent>
        <div
          [ngClass]="
            {
              type: entry.canalName,
              direction: entry.canalDirection
            } | channelIcon
          "
          aria-hidden="true"
          class="icon"
        ></div>
        <div class="content" truncate>
          <p>
            <span>{{ entry.entryDateStr }} </span>
            <span *ngIf="entry.canalName === 'PHONE' && entry.beginHourStr">
              &nbsp;-&nbsp;{{ entry.beginHourStr + ' ' + entry.endHourStr }}
            </span>
          </p>
          <p truncate *ngIf="entry.description" title="{{ entry.description }}">{{ entry.description }}</p>
        </div>
      </ng-template>

      <!-- TOOLTIP CONTENT -->
      <ng-template #tooltipContentRef>
        <ng-container *ngIf="entry && entry.memo && entry.memo.date && entry.memo.message">
          <p *ngIf="entry.memo.date" class="date">{{ entry.memo.date | localizedDate: 'short' }}</p>
          <p *ngIf="entry.memo.message">{{ entry.memo.message || '-' }}</p>
        </ng-container>
      </ng-template>
    </ng-container>
  </li>
</ul>
<ul class="timeline_actions" *ngIf="internalTimelineSortedByBeginDate.length > 0">
  <li *ngIf="canLink">
    <button (click)="link()" [disabled]="!hasTimelineToLink()">{{ 'agent:contact.mailactions.link' | translate }}</button>
  </li>
</ul>
